<template>
    <div class="c-form-row" :class="customClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['custom-class']
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-form-row{
        &:not(:last-child){
            margin-bottom: em($global-spacing-unit-small);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/form/Row.vue